import { Link } from 'react-router-dom';

const features = [
  {
    id: '1',
    icon: 'ri-flashlight-line',
    title: '极速追踪',
    description: '7×24小时实时监控全网热点，第一时间获取最新八卦动态，资讯快人一步。',
    href: '/category/daily-update',
  },
  {
    id: '2',
    icon: 'ri-search-eye-line',
    title: '深度扒皮',
    description: '专业编辑深入挖掘事件真相，多角度还原事实，拒绝标题党，做有态度的媒体。',
    href: '/category/scandal',
  },
  {
    id: '3',
    icon: 'ri-group-line',
    title: '社区热议',
    description: '百万活跃用户在线讨论，开启评论区畅所欲言，和吃瓜群众一起交流。',
    href: '/category/hot-comments',
  },
];

export default function FeatureMatrix() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20" aria-label="平台特色">
      <div className="w-full px-4 md:px-8 max-w-[1400px] mx-auto">
        <div className="flex flex-col items-start gap-3 mb-14">
          <p className="text-sm font-medium text-foreground-400 uppercase tracking-wider">
            为什么选择我们
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-foreground-950 leading-tight tracking-tight">
            一站式吃瓜平台
          </h2>
          <h3 className="text-3xl md:text-4xl lg:text-5xl font-black text-foreground-950 leading-tight tracking-tight">
            让娱乐资讯触手可及
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((feature) => (
            <Link
              key={feature.id}
              to={feature.href}
              className="group block bg-background-50 rounded-2xl p-8 transition-all duration-300 cursor-pointer"
            >
              <span className="w-14 h-14 flex items-center justify-center">
                <i className={`${feature.icon} text-3xl text-foreground-950`}></i>
              </span>
              <h3 className="mt-6 text-lg md:text-xl font-bold text-foreground-950">
                {feature.title}
              </h3>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed font-light">
                {feature.description}
              </p>
              <div className="mt-6 flex items-center gap-1 text-sm font-medium text-foreground-400 group-hover:text-primary-500 transition-colors duration-200">
                了解更多
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}